import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { ShippingTerms } from './shipping-terms.entity';
import { ShippingTermsAdapter } from './dto/shipping-terms.adapter';
import { ShippingTermsDTO } from './dto/shipping-terms.dto';
import { ShippingTermsResponseModel, AllShippingTermsResponseModel, ShippingTermsDropDownResponseModel, ShippingTermsDropDownDto } from '@gtpl/shared-models/masters';
import { ShippingTermsRequest } from './dto/shipping-terms.requests';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
@Injectable()
export class ShippingTermsService {
    constructor(
      private logService:LogsService,

        @InjectRepository(ShippingTerms)
        private shippingTermsRepository: Repository<ShippingTerms>,
        private shippingTermsAdapter: ShippingTermsAdapter,
      ) {}
    /**
     * create/update shippingTerms
     * @param shippingTermsDTO 
     * @param isUpdate 
     * @param request 
     */
    async createShippingTerms(shippingTermsDTO: ShippingTermsDTO, isUpdate: boolean,request:Request): Promise<ShippingTermsResponseModel> {
        try {
          let previousValue
            // to check whether ShippingTerms exists with the passed  ShippingTerms  or not. if isUpdate is false, a check will be done whether a record with the passed ShippingTerms is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed ShippingTerms  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
            const ShippingTermsEntity = await this.getShippingTermsDetailsWithoutRelations(shippingTermsDTO.shippingTermsName);

            if (ShippingTermsEntity) {
                throw new ShippingTermsResponseModel(false,11104, 'Shipping Term already exists');  
                       
            } 
            // var notificationStatus='Created';
            }
            if (isUpdate) {
                const ShippingTermsEntity = await this.getShippingTermsDetailsWithoutRelations(shippingTermsDTO.shippingTermsName);
                if (ShippingTermsEntity) {
                    throw new ShippingTermsResponseModel(false,11104, 'Shipping Term already exists');         
                } 
                const Previous = await this.shippingTermsRepository.findOne({where:{shippingTermsId:shippingTermsDTO.shippingTermsId}})
                previousValue =(Previous.shippingTermsName)
                // var notificationStatus='Created';
                }
            // else{
           
            // var notificationStatus='Updated';
            // }
            const convertedShippingTermsEntity: ShippingTerms = this.shippingTermsAdapter.convertDtoToEntity(shippingTermsDTO,isUpdate);
            const savedShippingTermsEntity: ShippingTerms = await this.shippingTermsRepository.save(
            convertedShippingTermsEntity
            );
            const savedShippingTermsDto: ShippingTermsDTO = this.shippingTermsAdapter.convertEntityToDto(savedShippingTermsEntity);
            if (savedShippingTermsDto) {
                const presentValue = shippingTermsDTO.shippingTermsName;
            // generating resposnse
            const response = new ShippingTermsResponseModel(true,isUpdate ? 11101 : 11100,isUpdate? 'ShippingTerms Updated Successfully': 'ShippingTerms Created Successfully',savedShippingTermsDto);
            const name=isUpdate?'updated':'created'
            const displayValue = isUpdate? 'ShippingTerms Updated Successfully': 'ShippingTerms Created Successfully'
            const userName = isUpdate? savedShippingTermsDto.updatedUser :savedShippingTermsDto.createdUser;
            const newLogDto = new LogsDto(1,name, 'ShippingTerms', savedShippingTermsDto.shippingTermsId, true, displayValue,userName,previousValue,presentValue)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
            } else {
            throw new ShippingTermsResponseModel(false,11106,'ShippingTerms saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }
    /**
     * get shippingTerms details
     * @param shippingTermsName 
     */
    // @LogActions({isAsync: true})
    async getShippingTermsDetailsWithoutRelations(shippingTermsName: string): Promise<ShippingTerms> {
        // tslint:disable-next-line: typedef
        const ShippingTermsResponse = await this.shippingTermsRepository.findOne({
        where: {shippingTermsName: Raw(alias => `shipping_term_name = '${shippingTermsName}'`)},
        });
        if (ShippingTermsResponse) {
        return ShippingTermsResponse;
        } else {
        return null;
        }
    }

     /**
     * gets all shippingTerms details  
     * @returns all shippingTerms details .
     */
    async getAllShippingTerms(req?:UserRequestDto): Promise<AllShippingTermsResponseModel> {
        // const page: number = 1;
        console.log(req,'creteduser')
        try {
          const shippingTermsDTO: ShippingTermsDTO[] = [];
          //retrieves all companies
          const shippingTermsEntities: ShippingTerms[] = await this.shippingTermsRepository.find({order :{shippingTermsName:'ASC'}});
          //console.log(shippingTermsEntities);
          if (shippingTermsEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            shippingTermsEntities.forEach(shippingTermsEntity => {
              const convertedshippingTermsDto: ShippingTermsDTO = this.shippingTermsAdapter.convertEntityToDto(
                shippingTermsEntity
              );
              shippingTermsDTO.push(convertedshippingTermsDto);
            });
            const response = new AllShippingTermsResponseModel(true,11108,"ShippingTerms retrieved successfully",shippingTermsDTO);
           if(req?.createdUser){
            const newLogDto = new LogsDto(1,'view', 'ShippingTerms', 0, true, 'ShippingTerms retrieved successfully',req.createdUser,'','')
            let res = await this.logService.createLog(newLogDto);
            console.log(req.createdUser);
            console.log(res);
           }
            
            return response;
          } else {
            throw new ShippingTermsResponseModel(false,99998, 'Data not found');
          }
        } catch (err) {
          throw err;
        }
      }
      async getAllActiveShippingTerms(): Promise<AllShippingTermsResponseModel> {
        // const page: number = 1;
        try {
            const shippingTermsDTO: ShippingTermsDTO[] = [];
            //retrieves all companies
            const ShippingTermsEntities: ShippingTerms[] = await this.shippingTermsRepository.find({ order: { shippingTermsName: 'ASC' },where:{isActive:true},
           });
         console.log(ShippingTermsEntities)
            if (ShippingTermsEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                ShippingTermsEntities.forEach(shippingTermsEntity => {
                    const convertedshippingTermsDTO: ShippingTermsDTO = this.shippingTermsAdapter.convertEntityToDto(
                      shippingTermsEntity
                    );
                    shippingTermsDTO.push(convertedshippingTermsDTO);
                });
                const response = new AllShippingTermsResponseModel(true, 11108, "ShippingTerms retrieved successfully", shippingTermsDTO);
                return response;
            } else {
                throw new ShippingTermsResponseModel(false,99998, 'Data not found'); shippingTermsDTO
            }
        } catch (err) {
            
            throw err;
        }
    }

    /**
     * It deactivates ShippingTerms 
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateShippingTerms(shippingTermsReq: ShippingTermsRequest): Promise<ShippingTermsResponseModel> {
      try {
          const shippingTermsExists = await this.getShippingTermsById(shippingTermsReq.shippingTermsId);
          if (shippingTermsExists) {
              if (shippingTermsReq.versionFlag !== shippingTermsExists.versionFlag) {
                  throw new ShippingTermsResponseModel(false,10113, 'Someone updated the current ShippingTerms information.Refresh and try again');
              } else {
                  
                      const shippingTermsStatus =  await this.shippingTermsRepository.update(
                          { shippingTermsId: shippingTermsReq.shippingTermsId },
                          { isActive: shippingTermsReq.isActive,updatedUser: shippingTermsReq.updatedUser });
                     
                      if (shippingTermsExists.isActive) {
                          if (shippingTermsStatus.affected) {
                              const shippingTermsResponse: ShippingTermsResponseModel = new ShippingTermsResponseModel(true, 10115, 'ShippingTerms is de-activated successfully');
                              return shippingTermsResponse;
                          } else {
                              throw new ShippingTermsResponseModel(false,10111, 'ShippingTerms is already deactivated');
                          }
                      } else {
                          if (shippingTermsStatus.affected) {
                              const shippingTermsResponse: ShippingTermsResponseModel = new ShippingTermsResponseModel(true, 10114, 'ShippingTerms is activated successfully');
                              return shippingTermsResponse;
                          } else {
                              throw new ShippingTermsResponseModel(false,10112, 'ShippingTerms is already activated');
                          }
                      }
                  // }
              }
          } else {
              throw new ShippingTermsResponseModel(false,99998, 'No Records Found');
          }
      } catch (err) {
          throw err;
      }
  }
    async getActiveShippingTermsById(shippingTermsReq: ShippingTermsRequest): Promise<ShippingTermsResponseModel> {
        try {
            //retrieves all companies
            const shippingEntities: ShippingTerms = await this.shippingTermsRepository.findOne({
              where:{shippingTermsId:shippingTermsReq.shippingTermsId}
              });
              
              const shippingData: ShippingTermsDTO = this.shippingTermsAdapter.convertEntityToDto(shippingEntities);
              if (shippingData) {
                  const response = new ShippingTermsResponseModel(true, 11101 , 'Shipping Terms retrived Successfully',shippingData);
                  return response;
              }
              else{
                  throw new ShippingTermsResponseModel(false,11106,'Something went wrong');
              }
              // generating resposnse
         } catch (err) {
            throw err;
        }
  }
  /**
   * get shippingTerms while passing id
   * @param shippingTermsId 
   */
  async getShippingTermsById(shippingTermsId: number): Promise<ShippingTerms> {
        const Response = await this.shippingTermsRepository.findOne({
        where: {shippingTermsId: shippingTermsId},
        });
        if (Response) {
        return Response;
        } else {
        return null;
        }
    }

    /**
     * 
     * @returns 
     */
    async getAllShippingTermsDropDown(): Promise<ShippingTermsDropDownResponseModel> {
        const paymentTermsDTO: ShippingTermsDropDownDto[] = [];
            const paymentTermsEntities: ShippingTerms[] = await this.shippingTermsRepository.find({ select: ['shippingTermsId', 'shippingTermsName'], where: { isActive: true }, order: { shippingTermsName: 'ASC' } });
            if (paymentTermsEntities && paymentTermsEntities.length > 0) {
                paymentTermsEntities.forEach(paymentTermsEntity => {
                    paymentTermsDTO.push(new ShippingTermsDropDownDto(paymentTermsEntity.shippingTermsId, paymentTermsEntity.shippingTermsName));
                });
                const response = new ShippingTermsDropDownResponseModel(true, 11108, "paymentTerms retrieved successfully", paymentTermsDTO);
                return response;
            } else {
                throw new ShippingTermsResponseModel(false,99998, 'Data not found');
            }
    }
      
}

